const Router = require("vue-router");
import i18n from "../utils/i18n";
import loginView from "@/views/Login";

const routes = [
  {
    path: "/login",
    name: "login",
    component: loginView,
    meta: { title: i18n.t("login.login") }
  }
];

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.afterEach((to, from) => {
  setTimeout(() => {
    const msgBoxWrappers = document.querySelectorAll(".el-message-box__wrapper");
    const loadingMasks = document.querySelectorAll('.el-loading-mask[style*="display: none"]');

    msgBoxWrappers.forEach(el => {
      if (el.style.display === "none" || !el.style.display) {
        try {
          el.remove();
        } catch (e) {}
      }
    });

    loadingMasks.forEach(el => {
      try {
        el.remove();
      } catch (e) {}
    });
  }, 100);
});

export default router;
